import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CommonOperationCardListing, CommonOperationCardAddEdit } from './Pages';

export const CommonOperationCardRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={CommonOperationCardListing} />
        <Route exact path={`${match.path}/AddEdit`} component={CommonOperationCardAddEdit} />
    </Fragment>
)